import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetActiveEmployeeApi } from "../employee/employeeAction";
import { Col, Container, Form, Row } from "react-bootstrap";
import { setHeading } from "../../../accounts/account.actions";
import { AddIncrementApi } from "./incrementAction";
import { appendNonSignificantZeros } from "../../../../../global/globalFunctions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Select from "react-select";
// import moment from "moment/moment";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddIncrement = (props) => {
    const [employeeId, setEmployeeId] = useState(0);
    const [employeeName, setEmployeeName] = useState("");
    const [incrementDecrement, setIncrementDecrement] = useState("");
    const [value, setValue] = useState(0);
    const [date, setDate] = useState(0);
    const [percentage, setPercentage] = useState(0);
    const [thisDisables1Field, setThisDisables1Field] = useState("");


    const SaveIncrement = () => {
        props.AddIncrementApi({
            employeeId: employeeId,
            type: incrementDecrement,
            value: Number(value),
            date: date,
            percentage: percentage,
        },
            showSuccessAlert,
            showErrorAlert,
        );
        setEmployeeId(0);
        setEmployeeName();
        setIncrementDecrement();
        setValue(0);
        setPercentage(0);
        setThisDisables1Field("");
    };

    const getEmployeeList = !_.isEmpty(props.activeEmployeeList) && props.activeEmployeeList.map((x) => {
        let data = { value: x._id, label: `${appendNonSignificantZeros(x.employeeName)}-${x.fatherName}-${x.cnic}` };
        return data
    })
    const handleChangeEmployee = (selectedOption) => {
        setEmployeeId(selectedOption.value);
        setEmployeeName(selectedOption.label);
    };

    const getincrementDecrementList = [
        { value: 1, label: "Increment" },
        { value: 0, label: "Decrement" },
    ];
    const handleChangeIncDec = (selectedOption) => {
        setIncrementDecrement(selectedOption.label);
    };
    const getTotalSalary = !_.isEmpty(employeeId) && _.find(props.activeEmployeeList, (x) => x._id === employeeId);


    useEffect(() => {
        props.GetActiveEmployeeApi();
        props.setHeading("Salary Increment")
    }, []);

    return (
        <Container fluid>
            {props.isFetchingActiveEmployeeData || props.isAddingIncrement ? (
                <GlobalSpinner />
            ) : (
                <div>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Select Employee *</b></Form.Label>
                                <Select
                                    isDisabled={_.isEmpty(getEmployeeList)}
                                    placeholder="Select Employee"
                                    onChange={handleChangeEmployee}
                                    options={getEmployeeList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Total Salary (Inc. Allowance) *</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Total Salary"
                                    value={getTotalSalary === false ? 0 : getTotalSalary.salary.totalSalary}
                                    disabled={true}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    // defaultValue={currentDate}
                                    placeholder="Date"
                                    onChange={(e) => setDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Select Increment / Decrement *</b></Form.Label>
                                <Select
                                    placeholder="Select Increment / Decrement"
                                    onChange={handleChangeIncDec}
                                    options={getincrementDecrementList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Value (In Amount) *</b></Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Value"
                                    value={value}
                                    onChange={(e) => {
                                        setValue(e.target.value);
                                        // setThisDisables1Field("IncrementValue");
                                        // setPercentage((e.target.value / getTotalSalary === false ? 0 : getTotalSalary.salary.totalSalary) * 100);
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col></Col>
                        {/* <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Percentage *</b></Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Percentage"
                                    step=".01"
                                    value={percentage}
                                    onChange={(e) => {
                                        setPercentage(e.target.value);
                                        setThisDisables1Field("IncrementPercentage");
                                        setValue((e.target.value * totalSalary) / 100);
                                    }}
                                    disabled
                                />
                            </Form.Group>
                        </Col> */}
                    </Row>

                    <div className="sendDiv">
                        {_.isEmpty(employeeName) || _.isEmpty(incrementDecrement) || _.isEmpty(date) || _.isEmpty(value) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => { SaveIncrement(); }}> SAVE </Button>
                        )}
                    </div>

                </div>
            )}
        </Container>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        AddIncrementApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddIncrementApi(data, showSuccessAlert, showErrorAlert)),
        GetActiveEmployeeApi: () => dispatch(GetActiveEmployeeApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingIncrement: state.IncrementReducer.isAddingIncrement,
    activeEmployeeList: state.EmployeeReducer.activeEmployeeList,
    isFetchingActiveEmployeeData: state.EmployeeReducer.isFetchingActiveEmployeeData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddIncrement);